export const mainData = {
  title: 'У вас остались вопросы или нужна помощь?',
  description:
    'Напишите в наш официальный аккаунт поддержки в WhatsApp или Telegram и мы ответим на любые вопросы',
  whatsappText: 'WhatsApp',
  telegramText: 'Telegram',
};
